// AppShellLayout.tsx — الهيكل العامّ بأسلوب shadcn-admin: قائمة جانبيّة «عائمة» (floating —
// بطاقة منفصلة بحواف مستديرة وظلّ وهامش حول الشاشة) + تخطيط «مضغوط» (compact — القائمة مطويّة
// افتراضيًّا لأيقونات فقط، ومحتوى أكثر كثافة).
import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { writeStorage } from '../lib/storage';
import { LAST_ADMIN_PATH_KEY } from './owner/PortalSwitcher';

const EXPANDED_WIDTH = 248;
const COLLAPSED_WIDTH = 72;

export function AppShellLayout() {
	const { i18n } = useTranslation();
	const location = useLocation();
	const [expanded, setExpanded] = useState(false);
	const isRtl = i18n.language === 'ar';
	const width = expanded ? EXPANDED_WIDTH : COLLAPSED_WIDTH;

	// يُسجَّل آخر مسار إداريّ زاره المستخدم — يقرأه PortalSwitcher عند العودة من بوابة المالك
	// (خطة OwnerPortalShell_Plan_2026-07-12.md §B4).
	useEffect(() => {
		writeStorage(LAST_ADMIN_PATH_KEY, location.pathname);
	}, [location.pathname]);

	return (
		<div dir={isRtl ? 'rtl' : 'ltr'} className="flex min-h-screen bg-background p-2 gap-2">
			<aside className="hidden shrink-0 transition-[width] duration-200 sm:block" style={{ width }}>
				<div className="sticky top-2 z-40 h-[calc(100svh-1rem)] overflow-hidden rounded-xl border border-sidebar-border shadow-sm" style={{ width }}>
					<Sidebar expanded={expanded} />
				</div>
			</aside>

			<div className="flex min-h-[calc(100svh-1rem)] flex-1 flex-col overflow-hidden rounded-xl border border-border bg-card shadow-sm">
				<Header onToggleSidebar={() => setExpanded((v) => !v)} />
				<main className="flex-1 overflow-y-auto p-3 md:p-4">
					<Outlet />
				</main>
			</div>
		</div>
	);
}
